module.exports = __webpack_public_path__ + "img/levelup-circle.fd9c7856.svg";